/* eslint-disable react/require-default-props */
import PropTypes from 'prop-types';

export default function Icon({ title = null, color = null }) {
  return (
    <svg role="img" aria-labelledby="closeIcon" width="100%" height="100%" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      {title && <title id="closeIcon">{title}</title>}
      <path d="M6 6L18 18M6 18L18 6L6 18Z" stroke={color || '#585F69'} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
    </svg>
  );
}

Icon.propTypes = {
  title: PropTypes.string,
  color: PropTypes.string,
};
